import RoamingStore from '../../stores/RoamingStore';
import { inject, observer } from 'mobx-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { Table, TableCell, Text } from 'telia-front-react';
import * as React from 'react';

interface OperatorGeneralInfoProps {
  roamingStore?: RoamingStore;
}

const OperatorGeneralInfo = (props: OperatorGeneralInfoProps): JSX.Element => {
  const { translate } = React.useContext(TranslationsContext);

  const getOperatorGeneralInfoTableRows = () => {
    const {
      roamingStore: { selectedOperator }
    } = props;
    const keyPrefix = `operator-${selectedOperator.id}`;
    const dataRows: any = [];
    if (selectedOperator.shortName) {
      pushRow(dataRows, `${keyPrefix}-short-name`, translate('roaming.operator.short-name'), selectedOperator.shortName);
    }
    if (selectedOperator.network) {
      pushRow(dataRows, `${keyPrefix}-network`, translate('roaming.operator.network'), selectedOperator.network);
    }
    if (selectedOperator.networkType) {
      pushRow(dataRows, `${keyPrefix}-network-type`, translate('roaming.operator.network-type'), selectedOperator.networkType);
    }
    if (selectedOperator.operatorCodes.length) {
      pushRow(dataRows, `${keyPrefix}-operator-code`, translate('roaming.operator.operator-code'), selectedOperator.operatorCodes.join('; '));
    }
    if (selectedOperator.operatorCodesOnBill.length) {
      pushRow(
        dataRows,
        `${keyPrefix}-operator-code-on-bill`,
        translate('roaming.operator.operator-code-on-bill'),
        selectedOperator.operatorCodesOnBill.join('; ')
      );
    }
    if (selectedOperator.intInfo) {
      pushRow(dataRows, `${keyPrefix}-international-info`, translate('roaming.operator.info-international'), selectedOperator.intInfo);
    }
    if (selectedOperator.infoOnGsm) {
      pushRow(dataRows, `${keyPrefix}-info-on-gsm`, translate('roaming.operator.info-on-gsm'), selectedOperator.infoOnGsm);
    }
    if (selectedOperator.openNetworks && selectedOperator.openNetworks.length) {
      pushRow(dataRows, `${keyPrefix}-open-networks`, translate('roaming.operator.open-networks'), selectedOperator.openNetworks.slice().sort().join(', '));
    }
    return dataRows;
  };

  const pushRow = (array: any[], key: string, name: string, value: string) => {
    array.push(
      <tr key={key}>
        <TableCell type="th" scope="row">
          {name}
        </TableCell>
        <TableCell>{value}</TableCell>
      </tr>
    );
  };

  return (
    <Text>
      <Table responsive="rows" className="text__margin-none">
        <tbody>{getOperatorGeneralInfoTableRows()}</tbody>
      </Table>
    </Text>
  );
};

export default inject('roamingStore')(observer(OperatorGeneralInfo));
